module.exports = __webpack_public_path__ + "img/70800.6feaba73.jpg";